import Cookies from "universal-cookie";

export const setCookie = (
  key: string,
  value: unknown,
  options: Record<string, unknown>
) => {
  const cookies = new Cookies();
  const name = `${key}`;
  const parsedValue = typeof value === "object" ? JSON.stringify(value) : value;
  cookies.set(name, parsedValue, {
    path: process.env.NEXT_PUBLIC_BASE_PATHNAME,
    ...options
  });
};

export const removeCookie = (key: string, options: Record<string, unknown>) => {
  const cookies = new Cookies();
  const name = `${key}`;
  cookies.remove(name, {
    path: process.env.NEXT_PUBLIC_BASE_PATHNAME,
    ...options
  });
};

export const getCookie = (key: string) => {
  const cookies = new Cookies();
  let value = cookies.get(`${key}`);
  try {
    value = JSON.parse(value);
    // eslint-disable-next-line no-empty
  } catch {}
  return value;
};
